
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 122.88 95.57"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.45 57.96h-.93c0-7.62-2.85-14.28-8.54-19.97-5.69-5.69-12.35-8.54-19.97-8.54v-.93c7.62 0 14.28-2.85 19.97-8.55C26.67 14.25 29.52 7.59 29.52 0h.93c0 7.62 2.85 14.28 8.54 19.97 5.69 5.69 12.35 8.54 19.97 8.54v.93c-7.62 0-14.28 2.85-19.97 8.54-5.69 5.7-8.54 12.36-8.54 19.98zM13.51 92.85h-.43c0-3.49-1.31-6.55-3.92-9.16-2.61-2.61-5.67-3.92-9.16-3.92v-.43c3.49 0 6.55-1.31 9.16-3.92 2.61-2.62 3.92-5.67 3.92-9.15h.43c0 3.49 1.31 6.55 3.92 9.16 2.61 2.61 5.66 3.92 9.16 3.92v.43c-3.49 0-6.55 1.31-9.16 3.92-2.62 2.6-3.92 5.66-3.92 9.15zm54.86 2.72h-.43c0-3.49-1.31-6.55-3.92-9.16-2.61-2.61-5.66-3.92-9.16-3.92v-.43c3.49 0 6.55-1.31 9.16-3.92 2.61-2.62 3.92-5.67 3.92-9.15h.43c0 3.49 1.31 6.55 3.92 9.16 2.61 2.61 5.66 3.92 9.16 3.92v.43c-3.49 0-6.55 1.31-9.16 3.92-2.62 2.6-3.92 5.65-3.92 9.15zm30.58-31h-.78c0-6.39-2.39-11.98-7.17-16.76-4.78-4.78-10.36-7.17-16.76-7.17v-.78c6.39 0 11.98-2.39 16.76-7.18 4.78-4.79 7.17-10.38 7.17-16.75h.78c0 6.39 2.39 11.98 7.17 16.76 4.78 4.78 10.36 7.17 16.76 7.17v.78c-6.39 0-11.98 2.39-16.76 7.17-4.78 4.78-7.17 10.37-7.17 16.76z","fill-rule":"evenodd","clip-rule":"evenodd"}})])
          )
        }
      }
    